interface ContentProps {
    text: string;
}

const Loading = ({text}: ContentProps) => {
    return (
        <div id="loading_page" className="loading-overlay">
            <div className="divbox_center">
                <div className="loading-spinner"></div>
                <h4 className="loading_text">{text}</h4>
            </div>
        </div>
    );
};

export default Loading;